import React, { Suspense } from 'react';

import ErrorBoundary from 'components/Common/ErrorBoundary';
import { CardSkeleton } from 'components/Skeleton';

// ECharts loads in its own chunk, only once a page draws a Studio chart
const StudioEChartContainer = React.lazy(
  () => import('./StudioEChartContainer'),
);

const LazyStudioEChart = (
  props: React.ComponentProps<typeof StudioEChartContainer>,
) => (
  <Suspense fallback={<CardSkeleton />}>
    <StudioEChartContainer {...props} />
  </Suspense>
);

// A Gauge block drawn with ECharts, in the same chunk
const StudioEGauge = React.lazy(() => import('./StudioEGauge'));

export const LazyStudioEGauge = (
  props: React.ComponentProps<typeof StudioEGauge>,
) => (
  <Suspense fallback={<CardSkeleton />}>
    <ErrorBoundary>
      <StudioEGauge {...props} />
    </ErrorBoundary>
  </Suspense>
);

export {
  canDrawWithECharts,
  isDrawnOnlyWithECharts,
  useIsEChartsRenderer,
} from './renderer';
export default LazyStudioEChart;
